<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <mat-icon class="sendIcon">email</mat-icon>
    <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
</h1>
<div fxFlex="row" mat-dialog-content>
    <div fxLayout="column" fxLayoutAlign=" start">
        <div>
            <mat-label>{{ 'general.provideEmail' | transloco }}</mat-label>
        </div>
        <form [formGroup]="emailForm">
            <mat-form-field appearance="fill">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" placeholder="Enter your email"/>
                <mat-error *ngIf="emailForm.controls['email'].hasError('email')">
                    Please enter a valid email address.
                </mat-error>
                <mat-error *ngIf="emailForm.controls['email'].hasError('required')">
                    Email is required.
                </mat-error>
            </mat-form-field>
            <br/>
            <br/>
            <button (click)="onClose()" mat-raised-button type="submit" [disabled]="!emailForm.valid">
                <mat-icon>send</mat-icon>
                {{ 'general.save' | transloco }}
            </button>
        </form>
    </div>
</div>
